<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center min-vh-100 p-3 text-center"
    style="background-color: #f8f9fa"
  >
    <keep-alive>
      <StepRegistration
        @next-step="nextStep"
        @prev-step="prevStep"
        v-if="currentStep === 1"
        :query="query"
        :updateShowLoading="updateShowLoading"
        @show-popup-send-otp="showPopupSendOtp"
      />
      <StepOtp
        @next-step="nextStep"
        @prev-step="prevStep"
        v-if="currentStep === 2"
        :query="query"
        :mobile="mobile"
        :updateShowLoading="updateShowLoading"
        :method="method"
      />
      <StepSuccess v-if="currentStep === 3" :query="query" />
    </keep-alive>

    <div class="footer-section text-center mt-3" style="font-size: 12px">
      <p class="text-uppercase mb-1 text-center" style="color: #666">
        CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ
      </p>
      <p class="text-center">
        Tầng 12A, toà nhà VTC Online, số 18 Tam Trinh,<br />phường Tương Mai, Hà Nội
      </p>
      <p class="text-center">
        Hotline: <a href="tel:1900636488">1900.63.64.88</a> | Email:
        <a href="mailto:hotro@mpos.vn">hotro@mpos.vn</a>
      </p>
    </div>
    <PopupSendOtp
      ref="popupSendOtpRef"
      :mobile="mobile"
      :query="query"
      @change="changeData"
      :updateShowLoading="updateShowLoading"
      @method="changeMethod"
      @next-step="nextStep"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import StepRegistration from './components/StepRegistration.vue'
  import StepOtp from './components/StepOtp.vue'
  import StepSuccess from './components/StepSuccess.vue'
  import PopupSendOtp from './components/PopupSendOtp.vue'
  import { contractNLGetInfoMerchant } from '@/services/customer-support/task'

  export default {
    components: {
      StepRegistration,
      StepOtp,
      StepSuccess,
      PopupSendOtp,
    },
    data() {
      return {
        currentStep: 1,
        query: {
          taskId: '',
          customerName: '',
          email: '',
          time: 0,
          checksum: '',
          source: undefined,
        },
        showLoading: false,
        transformStatus: '',
        mobile: '',
        method: '',
      }
    },
    created() {
      this.query.taskId = this.$route.query.taskId
      this.query.email = this.$route.query.email
      this.query.customerName = this.$route.query.customerName
      this.query.time = parseInt(this.$route.query.time) || 0
      this.query.checksum = this.$route.query.checksum
      this.$route.query.source && (this.query.source = this.$route.query.source)
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.updateShowLoading(true)
          const res = await contractNLGetInfoMerchant(this.query)
          if (res.code === 1000) {
            this.transformStatus = res.data?.transformStatus
            this.mobile = res.data?.mobile
            res.data?.merchantName && (this.query.customerName = res.data?.merchantName)
            res.data?.email && (this.query.email = res.data?.email)

            if (['NEW', 'NOTICE_MC'].includes(this.transformStatus)) {
              this.currentStep = 1
            } else if (
              ['MC_CONFIRMED', 'MC_ACTIVATED', 'ADDITIONAL_TID', 'ADDITIONAL_MID'].includes(
                this.transformStatus
              )
            ) {
              this.currentStep = 3
            }
          } else {
            this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(error.response?.data?.message ?? error.message)
        } finally {
          this.updateShowLoading(false)
        }
      },
      showPopupSendOtp() {
        this.$refs.popupSendOtpRef.show()
      },
      changeMethod(method) {
        this.method = method
      },
      updateShowLoading(value) {
        this.showLoading = value
      },
      nextStep() {
        this.currentStep++
      },
      prevStep() {
        this.currentStep--
      },
    },
  }
</script>

<!-- Không dùng scoped để CSS áp dụng được cho các component con -->
<style>
  @import '~@/assets/css/nganluong.css';
</style>
